{
  "fr": {
    "sublines": {
      "impressum": {
        "general": "General Information (according to § 5 TMG)",
        "disclaimer": "Avis de non-responsabilité",
        "copyright": "Droits d'auteur",
        "thirdpartycontent": "Crédits",
        "sponsors": "Sponsors",
        "liabilityInternal": "Limitation of liability for internal content",
        "liabilityExternal": "Limitation of liability for external links"
      }
    }
  }
}
